import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FLASHCARD_INPUT_MAX_LENGTH } from '../../common/constants';
import { FormTextField } from '../../common/Form/FormTextField';
import MssTooltip from '../../common/MssTooltip';

function EditDeckCardRow({
  card,
  cardIndex,
  isNew,
  isEdited,
  onFieldChange,
  onRemove,
  onAddBelow,
}) {
  const isNameOver = card.name.length > FLASHCARD_INPUT_MAX_LENGTH.NAME;
  const isDefinitionOver = card.definition.length > FLASHCARD_INPUT_MAX_LENGTH.DEFINITION;
  const isHintOver = (card.hint ?? '').length > FLASHCARD_INPUT_MAX_LENGTH.HINT;

  return (
    <Box className="cardRow" id={`editDeck__card_${cardIndex}`}>
      <Box className="cardRowHeader">
        <Box className="cardNumberGroup">
          <Typography className="cardNumber">Card {cardIndex + 1}</Typography>
          {isNew && <Typography className="cardEditedNote">Added by user</Typography>}
          {!isNew && isEdited && <Typography className="cardEditedNote">Edited by user</Typography>}
        </Box>
        <Box className="cardRowActions">
          <MssTooltip id={`editDeck__tooltip_addCard_${cardIndex}`} title="Add Card">
            <IconButton
              className="cardActionIcon"
              size="small"
              aria-label="Add card"
              id={`editDeck__button_addCard_${cardIndex}`}
              onClick={() => onAddBelow(cardIndex)}
            >
              <FontAwesomeIcon icon={faPlus} size="xs" />
            </IconButton>
          </MssTooltip>
          <MssTooltip id={`editDeck__tooltip_deleteCard_${cardIndex}`} title="Delete card">
            <IconButton
              className="cardActionIcon"
              size="small"
              aria-label="Delete card"
              id={`editDeck__button_deleteCard_${cardIndex}`}
              onClick={() => onRemove(cardIndex)}
            >
              <FontAwesomeIcon icon={faTrash} size="xs" />
            </IconButton>
          </MssTooltip>
        </Box>
      </Box>

      <Box className="cardFields">
        <FormTextField
          id={`editDeck__field_name_${cardIndex}`}
          label="Name"
          ariaLabel="Name"
          value={card.name}
          placeholder="Enter Name"
          onChange={(event) => onFieldChange(cardIndex, 'name', event.target.value)}
          error={isNameOver}
          helperText={
            isNameOver ? `Character count cannot exceed ${FLASHCARD_INPUT_MAX_LENGTH.NAME}` : ''
          }
          multiline
          minRows={1}
          fullWidth
        />
        <FormTextField
          id={`editDeck__field_definition_${cardIndex}`}
          label="Definition"
          ariaLabel="Definition"
          value={card.definition}
          placeholder="Enter Definition"
          onChange={(event) => onFieldChange(cardIndex, 'definition', event.target.value)}
          error={isDefinitionOver}
          helperText={
            isDefinitionOver
              ? `Character count cannot exceed ${FLASHCARD_INPUT_MAX_LENGTH.DEFINITION}`
              : ''
          }
          multiline
          minRows={1}
          fullWidth
        />
        <FormTextField
          id={`editDeck__field_hint_${cardIndex}`}
          label="Hint"
          ariaLabel="Hint"
          value={card.hint ?? ''}
          placeholder="Enter Hint"
          onChange={(event) => onFieldChange(cardIndex, 'hint', event.target.value)}
          error={isHintOver}
          helperText={
            isHintOver ? `Character count cannot exceed ${FLASHCARD_INPUT_MAX_LENGTH.HINT}` : ''
          }
          multiline
          minRows={1}
          fullWidth
        />
      </Box>
    </Box>
  );
}

export default EditDeckCardRow;
